import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const subscribeBonus = async (type: number, points: number, panelistId: number) => {
  return securePost("/api/user/subscribeBonus", { type, points, panelistId });
};

export const subscribeBonusPoints = async () => {
  return secureGet("/api/user/subscribeBonusPoints", {});
};